import React, {useState} from 'react';
import {Form, Input, Button, Card, message} from 'antd';
import {UserOutlined, LockOutlined} from '@ant-design/icons';
import {useNavigate} from 'react-router-dom';
import apiService from '../services/api';
// import {encryptAES} from '../services/encryption'
import '../styles/Login.css';
import '../services/api'
import CryptoJS from "crypto-js";

const {encryptPassword} = require("../utils/cryptoUtils")

const Login = () => {
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    // useState(() => {
    // apiService.user.register({
    //     phone: 'admin',
    //     password: CryptoJS.SHA256('qDB3dAMucQJAXQN0' + salt).toString(),
    //     verifyCode: '1234',
    //     userType: 4
    // })
    // String phone = registerParam.get("phone");
    // String password = registerParam.get("password");
    // String verifyCode = registerParam.get("verifyCode");
    // String userType = registerParam.get("userType");
    // }, [])

    const onFinish = async (values) => {
        setLoading(true);

        const loginData = {
            username: values.username,
            password: encryptPassword(values.password)
        }

        console.log('登录参数:', loginData);

        // apiService.user.login(loginData)
        //     .then(response => {
        //         console.log('登录成功:', response);
        //         // 通常这里会返回 token，可以保存到 localStorage
        //         localStorage.setItem('token', response.data.token);
        //         message.success('登录成功！');
        //         navigate('/formulas');
        //     }).catch(response => {
        //     console.log(response)
        //     // 可以在这里处理登录失败的情况
        //     message.error('登录失败，请检查用户名和密码！');
        // });
        const response = await apiService.user.login(loginData);
        console.log("登录返回的数据:", JSON.stringify(response.data))
        if (response && response.code === 200) {
            // 通常这里会返回 token，可以保存到 localStorage
            localStorage.setItem('token', response.data.token.token);
            message.success('登录成功！');
            navigate('/formulas');
        } else {
            console.log('登录失败:', response);
            message.error('登录失败，请检查用户名和密码！');
        }


        // message.success('登录成功！');
        // navigate('/formulas');
        // try {
        //   // 硬编码的账号密码验证
        //   if (values.username === 'rfpf' && values.password === '20250429') {
        //     // 模拟登录成功
        //     const token = 'eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiIxIiwiY3JlYXRlZCI6MTc0NTg5ODQ0NjE1MywiZXhwIjoxNzQ2NTAzMjQ2fQ.lqX5Y1qAWD41WJG9m8IxUetWaevD79D4tSrPY_HqPnDUmA-ZPcCwQmY9LRlDodyPGgpr9kDhLrY4s7mDUJe7Cg';
        //     localStorage.setItem('token', token);
        //     message.success('登录成功！');
        //     navigate('/formulas');
        //   } else {
        //     message.error('用户名或密码错误！');
        //   }
        // } catch (error) {
        //   message.error('登录失败: ' + (error.message || '未知错误'));
        // } finally {
        //   setLoading(false);
        // }
        setLoading(false);
    };

    return (
        <div className="login-container">
            <div className="login-background"></div>
            <div className="login-content">
                <Card className="login-card">
                    <div className="login-logo">
                        <h2 style={{fontSize: '24px', color: '#1890ff'}}>染发配方管理系统</h2>
                    </div>
                    <Form
                        name="login"
                        className="login-form"
                        initialValues={{remember: true}}
                        onFinish={onFinish}
                    >
                        <Form.Item
                            name="username"
                            rules={[{required: true, message: '请输入用户名!'}]}
                        >
                            <Input
                                prefix={<UserOutlined/>}
                                placeholder="请输入用户名"
                                size="large"
                            />
                        </Form.Item>
                        <Form.Item
                            name="password"
                            rules={[{required: true, message: '请输入密码!'}]}
                        >
                            <Input
                                prefix={<LockOutlined/>}
                                type="password"
                                placeholder="请输入密码"
                                size="large"
                            />
                        </Form.Item>
                        <Form.Item>
                            <Button
                                type="primary"
                                htmlType="submit"
                                className="login-button"
                                loading={loading}
                                size="large"
                                block
                            >
                                登录
                            </Button>
                        </Form.Item>
                    </Form>
                </Card>
            </div>
        </div>
    );
};

export default Login; 